import ArrayField from "./ArrayField";
import BooleanField from "./BooleanField";
import MultiSchemaField from "./MultiSchemaField";
import NumberField from "./NumberField";
import ObjectField from "./ObjectField";
import SchemaField from "./SchemaField";
import StringField from "./StringField";
import NullField from "./NullField";

function fields() {
  return {
    AnyOfField: MultiSchemaField,
    ArrayField: ArrayField,
    // ArrayField falls back to SchemaField if ArraySchemaField is not defined, which it isn't by default
    BooleanField: BooleanField,
    NumberField: NumberField,
    ObjectField: ObjectField,
    OneOfField: MultiSchemaField,
    SchemaField: SchemaField,
    StringField: StringField,
    NullField: NullField
  };
}

export default fields;